import * as React from 'react'
function SvgUser(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 22.8c5.157 0 8.78 1.982 10.868 3.59A5.469 5.469 0 0133 30.74v1.252A1.997 1.997 0 0131.003 34H8.997C7.895 34 7 33.1 7 31.992V30.74c0-1.691.766-3.301 2.132-4.351C11.221 24.782 14.843 22.8 20 22.8zM20 6c3.989 0 7.222 3.134 7.222 7S23.99 20 20 20c-3.989 0-7.222-3.134-7.222-7S16.01 6 20 6z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgUser
